module.exports = __webpack_public_path__ + "h5/img/bs_19.2119d19f.jpeg";